import { useEffect, useState } from "react";
import { Send } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { RoleBadge } from "@/components/Badges";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

export function Comments({ praticaId }) {
  const [list, setList] = useState([]);
  const [testo, setTesto] = useState("");
  useEffect(() => { api.get(`/pratiche/${praticaId}/commenti`).then((r) => setList(r.data)); }, [praticaId]);
  const send = async (e) => {
    e.preventDefault();
    if (!testo.trim()) return;
    try { const { data } = await api.post(`/pratiche/${praticaId}/commenti`, { testo }); setList([...list, data]); setTesto(""); } catch (err) { toast.error(formatApiError(err)); }
  };
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-5" data-testid="comments-panel">
      <h3 className="font-heading font-medium text-slate-900 mb-3">Note del team</h3>
      <div className="space-y-3 max-h-72 overflow-y-auto pr-1">
        {list.length === 0 && <p className="text-xs text-slate-500">Nessuna nota. Lascia un messaggio al team.</p>}
        {list.map((c) => (
          <div key={c.id} className="text-sm" data-testid={`comment-${c.id}`}>
            <div className="flex items-center gap-2"><span className="font-medium text-slate-900">{c.user_name}</span><RoleBadge role={c.user_role} /><span className="text-[11px] text-slate-400">{new Date(c.created_at).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" })}</span></div>
            <p className="text-slate-700 mt-0.5 whitespace-pre-wrap">{c.testo}</p>
          </div>
        ))}
      </div>
      <form onSubmit={send} className="mt-4 flex gap-2">
        <Textarea value={testo} onChange={(e) => setTesto(e.target.value)} rows={2} placeholder="Scrivi una nota…" className="bg-slate-50" data-testid="comment-input" />
        <Button type="submit" size="icon" className="bg-[#003087] hover:bg-[#0070BA] shrink-0 self-end" data-testid="comment-send-button"><Send size={15} /></Button>
      </form>
    </div>
  );
}
